"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ellipsis = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["style", "render", "count", "level"];
var Ellipsis = function Ellipsis(_ref) {
  var style = _ref.style,
    render = _ref.render,
    count = _ref.count,
    level = _ref.level,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var styl = (0, _objectSpread2["default"])({
    cursor: 'pointer'
  }, style);
  var className = "w-rjv-ellipsis ".concat(props.className || '');
  if (render) return render((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    style: styl,
    count: count,
    level: level
  }, props), {}, {
    className: className
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: className,
    style: styl
  }, props), {}, {
    children: "..."
  }));
};
exports.Ellipsis = Ellipsis;